<template>
    <a :class="['link', (isLight) ? 'light' : 'dark']" :href="anchor" @click="handler">
      <slot>{{label}}</slot>
    </a>
</template>

<script>
export default {
    name: 'VLink',
    props: {
        label: { type: String, },
        anchor: { type: String, default: "#" },
        isLight: { type: Boolean, default: false },
        handler: { type: Function, default: function(){} }
    }
};
</script>

<style scoped lang="scss">

.link {
    text-decoration: none;
    cursor: pointer;
}

.dark {
    &:link {
        color: #000000;
    }
    &:visited {
        color: #000000;
    }
    &:hover {
    }
    &:active {
    }
}
.light {
    &:link {
        color: rgb(228, 232, 236);
    }
    &:visited {
    }
    &:hover {
    }
    &:active {
    }
}
</style>